import { Col, Modal, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uid } from 'uid';

import {
  requestSavedSearches,
  requestSearchOptions,
  saveCompliassistSearch,
} from '@/src/compliance/redux/complianceReducer';
import { getSavedSearchesList } from '@/src/compliance/redux/selectors';
import Heading from '@/src/shared/components/Heading';
import Loading from '@/src/shared/components/LoadingResults';
import { space } from '@/styles';

import SavedSearchRow from './SavedSearchRow';
import style from './SavedSearchRow/style';

const { m } = space;
const index = props => {
  const { visible, closeModal } = props;

  const dispatch = useDispatch();

  const [refreshState, setRefreshState] = useState(uid());

  const { isFetchingCompliassistSavedSearches, savedSearches } = useSelector(
    state => state.compliance.savedSearches
  );

  const personId = useSelector(state => state.auth.userinfo.PersonID);

  const savedSearchesList = getSavedSearchesList(savedSearches);

  const H4Bold = ({ children, ..._props }) => (
    <Heading type={4} weight="bold" {..._props}>
      {children}
    </Heading>
  );
  useEffect(() => {
    if (personId) {
      dispatch(requestSavedSearches({ personId }));
    }
  }, [personId, refreshState]);

  useEffect(() => {
    dispatch(requestSearchOptions());
  }, []);

  return (
    <Modal
      footer={null}
      visible={visible}
      onCancel={closeModal}
      width="80%"
      maskStyle={{
        backgroundColor: 'rgba(0,38,73,0.65)',
      }}
      title={
        <Heading type={3} weight="bolder" theme="gray" css={m.b0}>
          My Saved Searches
        </Heading>
      }
    >
      <Heading type={4} css={m.b20} theme="gray">
        Listed below are the search criteria you’ve previously saved. These same saved searches are
        available on the home page in the “My APCIA” section.
      </Heading>

      {isFetchingCompliassistSavedSearches ? (
        <Loading />
      ) : (
        <>
          <Row gutter={16} type="flex" css={m.b16}>
            <Col xs={14}>
              <H4Bold theme="gray">My Saved Searches</H4Bold>
            </Col>
            <Col xs={3} css={style.hiddenTitle}>
              <H4Bold theme="gray">Edit</H4Bold>
            </Col>
            <Col xs={3} css={style.hiddenTitle}>
              <H4Bold theme="gray">Homepage</H4Bold>
            </Col>
          </Row>
          <div>
            {savedSearchesList.map(s => (
              <SavedSearchRow
                data={s}
                key={s.searchId}
                saveCompliassistSearch={saveCompliassistSearch}
                closeSavedSearchesModal={closeModal}
                setRefreshState={setRefreshState}
              />
            ))}
          </div>
        </>
      )}
    </Modal>
  );
};

index.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default index;
